import { useState } from 'react'

import type { SortChangedEvent } from 'ag-grid-community'

type UseAssessmentSortParams = {
  // With multiPhase the assessment status is gone, so it is never a sort field.
  multiPhase?: boolean
}

export function useAssessmentSort({ multiPhase = false }: UseAssessmentSortParams = {}) {
  const [sortField, setSortField] = useState<string | undefined>(undefined)
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc' | undefined>(undefined)

  function onSortChanged(event: SortChangedEvent) {
    const sorted = event.api
      .getColumnState()
      .find((c) => c.sort != null && !(multiPhase && c.colId === 'status'))
    setSortField(sorted?.colId)
    const sort = sorted?.sort
    setSortOrder(sort === 'asc' || sort === 'desc' ? sort : undefined)
  }

  return { sortField, sortOrder, onSortChanged }
}
